var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Pinia")]),_c('v-card-text',[_vm._v(_vm._s(_vm.authorized))]),_c('v-card-actions',[_c('v-btn',{on:{"click":_vm.testPinia}},[_vm._v("Test")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }